import React from 'react';
import IconBase from 'react-icons/lib/IconBase';

export const VercelLogo: React.FC<React.SVGAttributes<SVGElement>> = props => (
  <IconBase viewBox="0 0 116 100" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M57.5 0L115 100H0L57.5 0z" />
  </IconBase>
);
